export default __webpack_public_path__ + "static/photo360-68c294b75be279086da0dec64c14ee24.gif";